<script setup>
import { defineProps, defineEmits, ref, watch, computed} from "vue";
import { watchDebounced } from '@vueuse/core';
import { DateTime } from "luxon";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "revisandoPedido",
    "pedidoDeCompra",
    "item",
    "itensUnidades",
    "controlesDesativados",
]);

const emits = defineEmits([
    "update:item",
    "update:itens"
]);

//==================================================================//
//=========================== Formulario ===========================//
//==================================================================//

const formulario = ref(null);

//==================================================================//
//========================== Altera Itens ==========================//
//==================================================================//

const alteraItens = (update = {}) =>{

    update.status = "Valido";
    emits('update:itens', update);

};

//==================================================================//
//=========================== Altera Item ==========================//
//==================================================================//

const alteraItem = (update = {}) =>{

    update.status = "Valido";
    emits('update:item', update);

};

//==================================================================//
//=========================== Altera Item ==========================//
//==================================================================//

const alteraItemStatus = (status = "") =>{

    emits('update:item', {
        status: status
    });

};

//==================================================================//
//======= Preco Unitario Com Impostos Com Desconto Formatado =======//
//==================================================================//

const precoUnitarioComImpostosComDescontoFormatado = computed(()=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(props?.item?.osItemPrecoUnitarioComImpostosComDesconto);

});

//==================================================================//
//=============== Preco Total Com Impostos Formatado ===============//
//==================================================================//

const precoTotalComImpostosFormatado = computed(()=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(props?.item?.osItemPrecoTotalComImpostos);

});

//==================================================================//
//====================== Valor ICMS Formatado ======================//
//==================================================================//

const valorICMSFormatado = computed(()=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(props?.item?.osItemValorICMS);

});

//==================================================================//
//======================= Valor IPI Formatado ======================//
//==================================================================//

const valorIPIFormatado = computed(()=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(props?.item?.osItemValorIPI);

});

//==================================================================//
//=========== Preço Total sem Impostos com IPI Formatado ===========//
//==================================================================//

const precoTotalSemImpostosComIPIFormatado = computed(()=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(props?.item?.osItemPrecoTotalSemImpostosComIPI);

});

//==================================================================//
//============ Preço Total com Impostos com IPI Formatado ==========//
//==================================================================//

const precoTotalComImpostosComIPIFormatado = computed(()=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(props?.item?.osItemPrecoTotalComImpostosComIPI);

});

//==================================================================//
//==================== Item Data Entrega Regras ====================//
//==================================================================//

const itemDataEntregaRegras =  [
    valor => {

        // let dataAtual = DateTime.now().startOf('day');
        let dataEntrega = DateTime.fromISO(valor);

        if(!dataEntrega.isValid){
            return "Data inválida";
        }

        // if(dataEntrega < dataAtual){
        //     return "Data menor que hoje"
        // }

        return true;
    }
];

//==================================================================//
//============== Fornecedor Material Fornecido Regras ==============//
//==================================================================//

const fornecedorMaterialFornecidoRegras = [
    materialFornecido => {
        if(materialFornecido?.id){
            return true;
        }
        return 'Material Fornecido é obrigatório.';
       
    }
];

//==================================================================//
//================== Item Unidade Compras Regras ===================//
//==================================================================//

const itemUnidadeCompraRegras = [
    unidadeCompra => {
        if(unidadeCompra?.id){
            return true;
        }
        return 'Unidade é obrigatória.';
       
    }
];

//==================================================================//
//================= Item Quantidade Compras Regras =================//
//==================================================================//

const itemQuantidadeCompraRegras =  [
    valor => {
        if(valor === ""){
            return false;
        }else if(valor <= 0){
            return false;
        }
        return true;
    }
];

//==================================================================//
//============= Item Preço Unitario Com Impostos Regras ============//
//==================================================================//

const itemPrecoUnitarioComImpostosRegras =  [
    valor => {
        let valorFormatado = valor.replace(/,/g, ".");
        if(valorFormatado === ""){
            return false;
        }else if(0.00 >= parseFloat(valorFormatado)){
            return false;
        }
        return true;
    }
];

//==================================================================//
//= Item Preço Unitario Com Impostos Porcentagem do Desconto Regras //
//==================================================================//

const itemPrecoUnitarioComImpostosPorcentagemDoDescontoRegras =  [
    valor => {
        if(valor === ""){
            return false;
        }else if(valor < 0 || valor > 100){
            return false;
        }
        return true;
    }
];

//==================================================================//
//================== Item Porcentagem ISS Regras ===================//
//==================================================================//

const itemPorcentagemISSRegras =  [
    valor => {
        
        if(!props?.item?.osItemTemISS){
            return true;

        }else if(valor === ""){
            return false;

        }else if(valor <= 0 || valor > 100){

            return false;
        }
        
        return true;

    }
];

//==================================================================//
//================= Item Porcentagem ICMS Regras ===================//
//==================================================================//

const itemPorcentagemICMSRegras =  [
    valor => {

        if(!props?.item?.osItemTemICMS){
            return true;

        }
        else if(valor === ""){
            return false;

        }else if(valor <= 0 || valor > 100){
            return false;

        }

        return true;

    }
];

//==================================================================//
//================= Item Porcentagem IPI Regras ====================//
//==================================================================//

const itemPorcentagemIPIRegras =  [
    valor => {

        if(!props?.item?.osItemTemIPI){
            return true;

        }else if(valor === ""){
            return false;

        }else if(valor <= 0 || valor > 100){
            return false;

        }

        return true;

    }
];

//==================================================================//
//==================== Altera Quantidade Compra ====================//
//==================================================================//

const alteraQuantidadeCompra = (osItemQuantidadeCompra = 0) =>{

    alteraItem({
        osItemQuantidadeCompra: osItemQuantidadeCompra
    })

};

//==================================================================//
//====================== Altera Unidade Compra =====================//
//==================================================================//

const alteraUnidadeCompra = (osItemUnidadeCompra = 0) =>{

    alteraItem({
        osItemUnidadeCompra: osItemUnidadeCompra
    })

};

//==================================================================//
//================ Altera Preço Unitario Com Impostos ==============//
//==================================================================//

const alteraPrecoUnitarioComImpostos = (osItemPrecoUnitarioComImpostos = 0) =>{

    alteraItem({
        osItemPrecoUnitarioComImpostos: parseFloat(osItemPrecoUnitarioComImpostos)
    })

};

//==================================================================//
//======== Altera Preço Unitario Com Impostos Com Desconto =========//
//==================================================================//

const alteraPrecoUnitarioComImpostosPorcentagemDoDesconto = (osItemPrecoUnitarioComImpostosPorcentagemDoDesconto = 0)=>{

    alteraItem({
        osItemPrecoUnitarioComImpostosPorcentagemDoDesconto: osItemPrecoUnitarioComImpostosPorcentagemDoDesconto
    });

}


//==================================================================//
//========================= Altera Tem ISS =========================//
//==================================================================//

const alteraTemISS = () => {

    alteraItem({
        osItemTemISS: !props?.item?.osItemTemISS,
        osItemPorcentagemISS: 0
    });

};

//==================================================================//
//===================== Altera Porcentagem ISS =====================//
//==================================================================//

const alteraPorcentagemISS = (osItemPorcentagemISS) => {

    alteraItem({
        osItemPorcentagemISS: parseFloat(osItemPorcentagemISS)
    });

};

//==================================================================//
//======================== Altera Tem ICMS =========================//
//==================================================================//

const alteraTemICMS = () => {

    alteraItem({
        osItemTemICMS: !props?.item?.osItemTemICMS,
        osItemPorcentagemICMS: 0,
    });

};

//==================================================================//
//==================== Altera Porcentagem ICMS =====================//
//==================================================================//

const alteraPorcentagemICMS = (osItemPorcentagemICMS) => {

    alteraItem({
        osItemPorcentagemICMS: parseFloat(osItemPorcentagemICMS)
    });

};

//==================================================================//
//========================= Altera Tem IPI =========================//
//==================================================================//

const alteraTemIPI = () => {

    alteraItem({
        osItemTemIPI: !props?.item?.osItemTemIPI,
        osItemPorcentagemIPI: 0,
    });

};

//==================================================================//
//==================== Altera Porcentagem IPI =====================//
//==================================================================//

const alteraPorcentagemIPI = (osItemPorcentagemIPI) => {

    alteraItem({
        osItemPorcentagemIPI: parseFloat(osItemPorcentagemIPI)
    });

};

//==================================================================//
//======== Calcula Preco Unitario Com Impostos Com Desconto ========//
//==================================================================//

const calculaPrecoUnitarioComImpostosComDesconto = computed(()=>{

    return props?.item?.osItemPrecoUnitarioComImpostos - props?.item?.osItemPrecoUnitarioComImpostos * props?.item?.osItemPrecoUnitarioComImpostosPorcentagemDoDesconto / 100;

});

//==================================================================//
//========================== Desativa Item =========================//
//==================================================================//

const desativaItem = computed(()=>{

    if(props?.item?.leitura == true){
        return true
    }

    if(props?.controlesDesativados == true){
        return true
    }

    return false;

});

//==================================================================//
//======================== Esconde Duplicar ========================//
//==================================================================//

const escondeDuplicar = computed(()=>{

    if(props?.item?.leitura == true){
        return false
    }

    return true;

});

//==================================================================//
//===== Watch Calcula Preco Unitario Com Impostos Com Desconto =====//
//==================================================================//

watch(calculaPrecoUnitarioComImpostosComDesconto, (osItemPrecoUnitarioComImpostosComDesconto) => {

    alteraItem({
        osItemPrecoUnitarioComImpostosComDesconto: osItemPrecoUnitarioComImpostosComDesconto
    });

});

//==================================================================//
//=============== Calcula Preco Total Com Impostos =================//
//==================================================================//

const calculaPrecoTotalComImpostos = computed(()=>{

    return props?.item?.osItemQuantidadeCompra * props?.item?.osItemPrecoUnitarioComImpostosComDesconto;

});

//==================================================================//
//============= Watch Calcula Preco Total Com Impostos =============//
//==================================================================//

watch(calculaPrecoTotalComImpostos, (osItemPrecoTotalComImpostos) => {

    alteraItem({
        osItemPrecoTotalComImpostos: osItemPrecoTotalComImpostos
    });

});

//==================================================================//
//====================== Calcula Valor PIS =========================//
//==================================================================//

const calculaValorPIS = computed(()=>{

    return props?.item?.osItemPrecoTotalComImpostos * props?.item?.osItemPorcentagemPIS / 100;

});

//==================================================================//
//==================== Watch Calcula Valor PIS =====================//
//==================================================================//

watch(calculaValorPIS, (osItemValorPIS) => {

    alteraItem({
        osItemValorPIS: osItemValorPIS
    });

});

//==================================================================//
//==================== Calcula Valor COFINS ========================//
//==================================================================//

const calculaValorCOFINS = computed(()=>{

    return props?.item?.osItemPrecoTotalComImpostos * props?.item?.osItemPorcentagemCOFINS / 100;

});

//==================================================================//
//=================== Watch Calcula Valor COFINS ===================//
//==================================================================//

watch(calculaValorCOFINS, (osItemValorCOFINS) => {

    alteraItem({
        osItemValorCOFINS: osItemValorCOFINS
    });

});

//==================================================================//
//====================== Calcula Valor ICMS ========================//
//==================================================================//

const calculaValorICMS = computed(()=>{

    return props?.item?.osItemPrecoTotalComImpostos * props?.item?.osItemPorcentagemICMS / 100;

});

//==================================================================//
//=================== Watch Calcula Valor ICMS =====================//
//==================================================================//

watch(calculaValorICMS, (osItemValorICMS) => {

    alteraItem({
        osItemValorICMS: osItemValorICMS
    });

});

//==================================================================//
//====================== Calcula Valor IPI =========================//
//==================================================================//

const calculaValorIPI = computed(()=>{

    return props?.item?.osItemPrecoTotalComImpostos * props?.item?.osItemPorcentagemIPI / 100;

});

//==================================================================//
//=================== Watch Calcula Valor IPI ======================//
//==================================================================//

watch(calculaValorIPI, (osItemValorIPI) => {

    alteraItem({
        osItemValorIPI: osItemValorIPI
    });

});

//==================================================================//
//========== Calcula Preco Total Sem Impostos Com IPI ==============//
//==================================================================//

const calculaPrecoTotalSemImpostosComIPI = computed(()=>{

    return props?.item?.osItemPrecoTotalComImpostos - (props?.item?.osItemValorPIS + props?.item?.osItemValorCOFINS + props?.item?.osItemValorICMS) + props?.item?.osItemValorIPI;

});

//==================================================================//
//====== Watch Calcula Preco Total Sem Impostos Com IPI ============//
//==================================================================//

watch(calculaPrecoTotalSemImpostosComIPI, (osItemPrecoTotalSemImpostosComIPI) => {

    alteraItem({
        osItemPrecoTotalSemImpostosComIPI: osItemPrecoTotalSemImpostosComIPI
    });

});

//==================================================================//
//========== Calcula Preco Total Com Impostos Com IPI ==============//
//==================================================================//

const calculaPrecoTotalComImpostosComIPI = computed(()=>{

    return props?.item?.osItemPrecoTotalComImpostos + props?.item?.osItemValorIPI;

});

//==================================================================//
//====== Watch Calcula Preco Total Com Impostos Com IPI ============//
//==================================================================//

watch(calculaPrecoTotalComImpostosComIPI, (osItemPrecoTotalComImpostosComIPI) => {

    alteraItem({
        osItemPrecoTotalComImpostosComIPI: osItemPrecoTotalComImpostosComIPI
    });

});

//==================================================================//
//=================== Clona Porcentagem ISS ========================//
//==================================================================//

const clonaPorcentagemISS = (()=>{

    alteraItens({
        osItemTemISS: true,
        osItemPorcentagemISS: props?.item?.osItemPorcentagemISS
    });

});

//==================================================================//
//==================== Desativa Porcentagem ISS ====================//
//==================================================================//

const desativaPorcentagemISS = computed(()=>{

    if(desativaItem.value == true){
        return true;
    }
    
    if(!props?.pedidoDeCompra.fornecedor?.id){
        return true
    }

    if(!props?.item?.osItemTemISS == true){
        return true;
    }

    return false;

});

//==================================================================//
//=================== Clona Porcentagem ICMS =======================//
//==================================================================//

const clonaPorcentagemICMS = (()=>{

    alteraItens({
        osItemTemICMS: true,
        osItemPorcentagemICMS: props?.item?.osItemPorcentagemICMS
    });

});

//==================================================================//
//=================== Desativa Porcentagem ICMS ====================//
//==================================================================//

const desativaPorcentagemICMS = computed(()=>{

    if(desativaItem.value == true){
        return true;
    }
    
    if(!props?.pedidoDeCompra.fornecedor?.id){
        return true
    }

    if(!props?.item?.osItemTemICMS == true){
        return true;
    }

    return false;

});

//==================================================================//
//=================== Clona Porcentagem IPI =======================//
//==================================================================//

const clonaPorcentagemIPI = (()=>{

    alteraItens({
        osItemTemIPI: true,
        osItemPorcentagemIPI: props?.item?.osItemPorcentagemIPI
    });

});

//==================================================================//
//=================== Desativa Porcentagem IPI =====================//
//==================================================================//

const desativaPorcentagemIPI = computed(()=>{

    if(desativaItem.value == true){
        return true;
    }
    
    if(!props?.pedidoDeCompra.fornecedor?.id){
        return true
    }

    if(!props?.item?.osItemTemIPI == true){
        return true;
    }

    return false;

});

//==================================================================//
//==================== Data Entrega Formatada ======================//
//==================================================================//

const dataEntregaFormatada = () =>{

    let dataEntrega = DateTime.fromFormat(props?.item?.osItemDataEntrega,"dd/MM/yyyy");
    return dataEntrega.toFormat("yyyy-MM-dd");

};

//==================================================================//
//===================== Altera Data Entrega ========================//
//==================================================================//

const alteraDataEntrega = (osItemDataEntrega)=>{

    let dataEntrega = DateTime.fromFormat(osItemDataEntrega,"yyyy-MM-dd");
    dataEntrega = dataEntrega.toFormat("dd/MM/yyyy");

    alteraItem({
        osItemDataEntrega: dataEntrega
    });

};

//==================================================================//
//=================== Clona Porcentagem IPI ========================//
//==================================================================//

const clonaDataEntrega = (()=>{

    alteraItens({
        osItemDataEntrega: props?.item?.osItemDataEntrega
    });

});

//==================================================================//
//=============== Altera Fornecedor Material Fornecido =============//
//==================================================================//

const alteraFornecedorMaterialFornecido = (osItemFornecedorMaterialFornecido)=>{

    alteraItem({
        osItemFornecedorMaterialFornecido: osItemFornecedorMaterialFornecido
    })

};

//==================================================================//
//============ Clona Fornecedor Material Fornecido =================//
//==================================================================//

const clonaFornecedorMaterialFornecido = (()=>{

    alteraItens({
        osItemFornecedorMaterialFornecido: props?.item?.osItemFornecedorMaterialFornecido
    });

});

//==================================================================//
//============= Desativa Fornecedor Material Fornecido =============//
//==================================================================//

const desativaFornecedorMaterialFornecido = computed(()=>{

    if(desativaItem.value == true){
        return true;
    }
    
    if(!props?.pedidoDeCompra.fornecedor?.id){
        return true
    }

    return false;

});

//==================================================================//
//=========================== Validate =============================//
//==================================================================//

const validate = () =>{

    return formulario.value.validate();

}

//==================================================================//
//====================== Validate Formatado ========================//
//==================================================================//

const validateFormatado = computed(()=>{

    return validate() ? "Valido" : "Invalido";

});

//==================================================================//
//================== Watch Effect => Item ==========================//
//==================================================================//

watchDebounced(() => props?.item, () => {

    let itemStatusAtual = props?.item?.status;
    let itemStatusValidacao = validateFormatado.value;

    // Se Item já está Salvo, porem uma Alteração tornou ele Invalido.
    if(itemStatusAtual == "Salvo" && itemStatusValidacao == "Invalido"){

        alteraItemStatus("Invalido");

    }

    // Se Item está Valido, porem uma Alteração tornou ele Invalido.
    if(itemStatusAtual == "Valido" && itemStatusValidacao == "Invalido"){

        alteraItemStatus("Invalido");

    }

    // Se Item está Invalido, porem uma Alteração tornou ele Valido.
    if(itemStatusAtual == "Invalido" && itemStatusValidacao == "Valido"){

        alteraItemStatus("Valido");
 
    }

},{ debounce: 500, maxWait: 1000 })

</script>

<template>

    <tr class="c-expancao-linha"
        v-show="props?.item?.aberto"
    >

        <td class="c-expancao-linha"
            colspan="18"
        >

            <v-form
                ref="formulario"
                class="c-formulario"
            >
                
                <div class="c-formulario__grupos">

                    <div class="c-formulario__grupo">

                        <div class="c-grupo__titulo">

                            <h3 class="c-titulo__texto">
                                Item
                            </h3>
                            
                        </div>

                        <div class="c-grupo__conteudo c-grupo__conteudo--espacado">

                            <div class="c-sub-grupo">

                                <div class="c-sub-grupo__titulo">
                                    
                                    <h3 class="c-titulo__texto">
                                        Item Solicitado
                                    </h3>
                                    
                                </div>

                                <div class="c-sub-grupo__conteudo">

                                    <div class="c-campo">

                                        <v-text-field
                                            class="c-campo__input"
                                            :value="props?.item?.osItemQuantidade"
                                            label="Quantidade Solicitada"
                                            outlined
                                            type="number"
                                            prepend-icon="mdi-counter"
                                            disabled
                                        ></v-text-field>

                                    </div>

                                    <div class="c-campo">

                                        <v-select class="c-campo__input"
                                            label="Unidade Solicitada"
                                            :value="props?.item?.osItemUnidade"
                                            :items="props?.itensUnidades"
                                            :item-props="true"
                                            :item-text="item => `${item.sigla}`"
                                            disabled
                                            outlined
                                            return-object
                                            prepend-icon="mdi-cube-outline"
                                        >

                                            <template v-slot:item="{ item }">
                                                {{item.sigla}}
                                            </template>

                                        </v-select>

                                    </div>

                                </div>

                            </div>

                            <div class="c-sub-grupo">

                                <div class="c-sub-grupo__titulo">
                                    
                                    <h3 class="c-titulo__texto">
                                        Item Compra
                                    </h3>
                                    
                                </div>

                                <div class="c-sub-grupo__conteudo">
                                    
                                    <div class="c-campo">

                                        <v-text-field
                                            class="c-campo__input"
                                            :value="props?.item?.osItemQuantidadeCompra"
                                            label="Quantidade"
                                            outlined
                                            type="number"
                                            prepend-icon="mdi-counter"
                                            :rules="itemQuantidadeCompraRegras"
                                            :disabled="desativaItem"
                                            @input="alteraQuantidadeCompra"
                                        ></v-text-field>

                                    </div>

                                    <div class="c-campo">

                                        <v-select class="c-campo__input"
                                            label="Unidade"
                                            :value="props?.item?.osItemUnidadeCompra"
                                            :items="props?.itensUnidades"
                                            :item-props="true"
                                            :item-text="item => `${item.sigla}`"
                                            :rules="itemUnidadeCompraRegras"
                                            :disabled="desativaItem"
                                            outlined
                                            return-object
                                            prepend-icon="mdi-cube-outline"
                                            @input="alteraUnidadeCompra"
                                        >

                                            <template v-slot:item="{ item }">
                                                {{item.sigla}}
                                            </template>

                                        </v-select>

                                    </div>

                                </div>

                            </div>


                        </div>

                    </div>

                    <div class="c-formulario__grupo">

                        <div class="c-grupo__titulo">

                            <h3 class="c-titulo__texto">
                                Preço
                            </h3>
                            
                        </div>

                        <div class="c-grupo__conteudo">

                            <div class="c-campo">

                                <vuetify-money
                                    class="c-campo__input"
                                    :value="props?.item?.osItemPrecoUnitarioComImpostos"
                                    label="Preço Unitário"
                                    outlined
                                    type="number"
                                    :rules="itemPrecoUnitarioComImpostosRegras"
                                    :disabled="desativaItem"
                                    :properties="{ 
                                        'class':'c-campo__input',
                                        'prepend-icon':'mdi-currency-brl'
                                    }"
                                    @input="alteraPrecoUnitarioComImpostos"
                                    
                                ></vuetify-money>

                            </div>

                            <div class="c-campo">

                                <v-text-field class="c-campo__input"
                                    :value="props?.item?.osItemPrecoUnitarioComImpostosPorcentagemDoDesconto"
                                    label="%Desconto"
                                    outlined
                                    type="number"
                                    prepend-icon="mdi-percent"
                                    :rules="itemPrecoUnitarioComImpostosPorcentagemDoDescontoRegras"
                                    :disabled="desativaItem"
                                    @input="alteraPrecoUnitarioComImpostosPorcentagemDoDesconto"
                                ></v-text-field>

                            </div>

                            <div class="c-campo">
                        
                                <v-text-field class="c-campo__input"
                                    :value="precoUnitarioComImpostosComDescontoFormatado"
                                    label="Preço Unitário com Desconto"
                                    outlined
                                    disabled
                                    prepend-icon="mdi-currency-brl"
                                ></v-text-field>
                        
                            </div>

                            <div class="c-campo">

                                <v-text-field class="c-campo__input"
                                    :value="precoTotalComImpostosFormatado"
                                    label="Preço Total"
                                    outlined
                                    disabled
                                    prepend-icon="mdi-currency-brl"
                                ></v-text-field>

                            </div>

                        </div>

                    </div>

                    <div class="c-formulario__grupo c-formulario__grupo--espacado">

                        <div class="c-grupo__titulo">
                            
                            <h3 class="c-titulo__texto">
                                Impostos
                            </h3>
                            
                        </div>

                        <div class="c-grupo__conteudo c-grupo__conteudo--espacado">

                            <div class="c-sub-grupo">

                                <div class="c-sub-grupo__titulo">
                                    
                                    <v-simple-checkbox class="c-titulo__checkbox"
                                        color="primary"
                                        :value="props?.item?.osItemTemISS"
                                        :disabled="desativaItem"
                                        @input="alteraTemISS"
                                    >
                                    </v-simple-checkbox>

                                    <h3 class="c-titulo__texto">
                                        ISS
                                    </h3>
                                    
                                </div>

                                <div class="c-sub-grupo__conteudo">

                                    <div class="c-campo c-campo--com-botao">
                                    
                                        <v-text-field class="c-campo__input"
                                            :value="props?.item?.osItemPorcentagemISS"
                                            type="number"
                                            label="%ISS"
                                            outlined
                                            prepend-icon="mdi-percent"
                                            :rules="itemPorcentagemISSRegras"
                                            :disabled="desativaPorcentagemISS"
                                            :required="props?.item?.osItemTemISS"
                                            @input="alteraPorcentagemISS"
                                        ></v-text-field>

                                        <v-tooltip bottom>

                                            <template v-slot:activator="{ on, attrs }">

                                                <v-btn
                                                    v-show="escondeDuplicar"
                                                    class="c-campo__botao c-campo__clona-valor"
                                                    fab
                                                    dark
                                                    x-small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :disabled="desativaPorcentagemISS"
                                                    @click="clonaPorcentagemISS"
                                                >

                                                    <v-icon dark>
                                                        mdi-content-duplicate
                                                    </v-icon>
                                                
                                                </v-btn>

                                            </template>

                                            <span>Clona essa porcentagem de ISS para todos os Itens</span>

                                        </v-tooltip>

                                    </div>

                                </div>

                            </div>

                            <div class="c-sub-grupo">

                                <div class="c-sub-grupo__titulo">
                                    
                                    <v-simple-checkbox class="c-titulo__checkbox"
                                        color="primary"
                                        :value="props?.item?.osItemTemICMS"
                                        :disabled="desativaItem"
                                        @input="alteraTemICMS"
                                    >
                                    </v-simple-checkbox>

                                    <h3
                                        class="c-titulo__texto"
                                    >
                                        ICMS
                                    </h3>
                                    
                                </div>

                                <div class="c-sub-grupo__conteudo">

                                    <div class="c-campo c-campo--com-botao">
                                
                                        <v-text-field class="c-campo__input"
                                            :value="props?.item?.osItemPorcentagemICMS"
                                            label="%ICMS"
                                            outlined
                                            type="number"
                                            prepend-icon="mdi-percent"
                                            :rules="itemPorcentagemICMSRegras"
                                            :disabled="desativaPorcentagemICMS"
                                            :required="props?.item?.osItemTemICMS"
                                            @input="alteraPorcentagemICMS"
                                        ></v-text-field>

                                        <v-tooltip bottom>

                                            <template v-slot:activator="{ on, attrs }">

                                                <v-btn
                                                    v-show="escondeDuplicar"
                                                    class="c-campo__botao c-campo__clona-valor"
                                                    fab
                                                    dark
                                                    x-small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :disabled="desativaPorcentagemICMS"
                                                    @click="clonaPorcentagemICMS"
                                                >

                                                    <v-icon dark>
                                                        mdi-content-duplicate
                                                    </v-icon>
                                                
                                                </v-btn>

                                            </template>

                                            <span>Clona essa porcentagem do ICMS para todos os Itens</span>

                                        </v-tooltip>
                                
                                    </div>

                                    <div class="c-campo">

                                        <v-text-field class="c-campo__input"
                                            :value="valorICMSFormatado"
                                            label="Valor ICMS"
                                            outlined
                                            disabled
                                            prepend-icon="mdi-currency-brl"
                                        ></v-text-field>

                                    </div>

                                </div>

                            </div>

                            <div class="c-sub-grupo">

                                <div class="c-sub-grupo__conteudo">

                                    <div class="c-sub-grupo__titulo">
                                        
                                        <v-simple-checkbox class="c-titulo__checkbox"
                                            color="primary"
                                            :value="props?.item?.osItemTemIPI"
                                            :disabled="desativaItem"
                                            @input="alteraTemIPI"
                                        >
                                        </v-simple-checkbox>

                                        <h3 class="c-titulo__texto">
                                            IPI
                                        </h3>
                                        
                                    </div>

                                    <div class="c-campo c-campo--com-botao">

                                        <v-text-field class="c-campo__input"
                                            :value="props?.item?.osItemPorcentagemIPI"
                                            label="%IPI"
                                            outlined
                                            type="number"
                                            prepend-icon="mdi-percent"
                                            :rules="itemPorcentagemIPIRegras"
                                            :disabled="desativaPorcentagemIPI"
                                            :required="props?.item?.osItemTemIPI"
                                            @input="alteraPorcentagemIPI"
                                        ></v-text-field>

                                        <v-tooltip bottom>

                                            <template v-slot:activator="{ on, attrs }">

                                                <v-btn
                                                    v-show="escondeDuplicar"
                                                    class="c-campo__botao c-campo__clona-valor"
                                                    fab
                                                    dark
                                                    x-small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :disabled="desativaPorcentagemIPI"
                                                    @click="clonaPorcentagemIPI"
                                                >

                                                    <v-icon dark>
                                                        mdi-content-duplicate
                                                    </v-icon>
                                                
                                                </v-btn>

                                            </template>

                                            <span>Clona essa porcentagem do IPI para todos os Itens</span>

                                        </v-tooltip>

                                    </div>

                                    <div class="c-campo">

                                        <v-text-field class="c-campo__input"
                                            :value="valorIPIFormatado"
                                            label="Valor IPI"
                                            outlined
                                            disabled
                                            prepend-icon="mdi-currency-brl"
                                        ></v-text-field>

                                    </div>

                                    <div class="c-campo">

                                        <v-text-field class="c-campo__input"
                                            :value="precoTotalSemImpostosComIPIFormatado"
                                            label="Preço Total sem Impostos com IPI"
                                            outlined
                                            disabled
                                            prepend-icon="mdi-currency-brl"
                                        ></v-text-field>

                                    </div>

                                    <div class="c-campo">

                                        <v-text-field class="c-campo__input"
                                            :value="precoTotalComImpostosComIPIFormatado"
                                            label="Preço Total com Impostos com IPI"
                                            outlined
                                            disabled
                                            prepend-icon="mdi-currency-brl"
                                        ></v-text-field>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div class="c-formulario__grupo">

                        <div class="c-grupo__titulo">

                            <h3 class="c-titulo__texto">
                                Condições Gerais
                            </h3>
                            
                        </div>

                        <div class="c-grupo__conteudo">

                            <div class="c-campo c-campo--com-botao">

                                <v-text-field class="c-campo__input"
                                    :value="dataEntregaFormatada()"
                                    label="Data Entrega"
                                    outlined
                                    type="date"
                                    prepend-icon="mdi-calendar" 
                                    :rules="itemDataEntregaRegras"
                                    :disabled="desativaItem"
                                    @input="alteraDataEntrega"
                                ></v-text-field>

                                <v-tooltip bottom>

                                    <template v-slot:activator="{ on, attrs }">

                                        <v-btn
                                            v-show="escondeDuplicar"
                                            class="c-campo__botao c-campo__clona-valor"
                                            fab
                                            dark
                                            x-small
                                            color="primary"
                                            v-bind="attrs"
                                            v-on="on"
                                            :disabled="desativaItem"
                                            @click="clonaDataEntrega"
                                        >

                                            <v-icon dark>
                                                mdi-content-duplicate
                                            </v-icon>
                                        
                                        </v-btn>

                                    </template>

                                    <span>Clona essa data de entrega para todos os Itens</span>

                                </v-tooltip>

                            </div>

                            <div class="c-campo c-campo--com-botao">

                                <v-select class="c-campo__input"
                                    label="Material Fornecido"
                                    :value="props?.item?.osItemFornecedorMaterialFornecido"
                                    :items="props?.pedidoDeCompra?.fornecedor?.materiais"
                                    :item-props="true"
                                    :item-text="item => `${item.codigo} - ${item.descricao}`"
                                    :rules="fornecedorMaterialFornecidoRegras"
                                    :disabled="desativaFornecedorMaterialFornecido"
                                    outlined
                                    return-object
                                    prepend-icon="mdi-cube-outline"
                                    @input="alteraFornecedorMaterialFornecido"
                                >

                                    <template v-slot:item="{ item }">
                                        {{item.codigo}} - {{item.descricao}}
                                    </template>

                                </v-select>

                                <v-tooltip bottom>

                                    <template v-slot:activator="{ on, attrs }">

                                        <v-btn
                                            v-show="escondeDuplicar"
                                            class="c-campo__botao c-campo__clona-valor"
                                            fab
                                            dark
                                            x-small
                                            color="primary"
                                            v-bind="attrs"
                                            v-on="on"
                                            :disabled="desativaFornecedorMaterialFornecido"
                                            @click="clonaFornecedorMaterialFornecido"
                                        >

                                            <v-icon dark>
                                                mdi-content-duplicate
                                            </v-icon>
                                        
                                        </v-btn>

                                    </template>

                                    <span>Clona esse material fornecido para todos os Itens</span>

                                </v-tooltip>
                        
                            </div>

                        </div>

                    </div>

                </div>

            </v-form>

        </td>

    </tr>

</template>

<style scoped>

.c-formulario{
    background-color: #e9e9e9;
    padding: 5px;
}

.c-formulario__grupos{
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: 16px;
    padding: 18px 16px 16px 16px;
    align-items: baseline;
    width: calc(100vw - (16px + 12px + 12px + 25px));
    background-color: white;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
}

.c-formulario__grupo{
    padding: 5px;
    background: #f5f5f5;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
}

.c-grupo__conteudo--espacado{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.c-grupo__titulo{
    display: grid;
    grid-auto-flow: column;
    justify-content: center;
    grid-gap: 10px;
    padding: 10px 20px 10px 10px;
}

.c-titulo__texto{
    margin-bottom: 0 !important;
}

.c-sub-grupo{
    border-radius: 5px;
    padding: 0px 10px;
    margin: 5px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px, rgb(227 227 227) 0px 0px 0px 3px;
}

.c-sub-grupo__titulo{
    display: grid;
    grid-auto-flow: column;
    justify-content: left;
    grid-gap: 10px;
    padding: 10px 20px 10px 10px;
}

.c-sub-grupo__titulo > .c-titulo__checkbox > .v-input--selection-controls__input{
    margin: 0 !important;
}

.c-sub-grupo__titulo > .c-titulo__texto{
    margin-bottom: 0 !important;
}

.c-campo--com-botao{
    display: flex;
}

.c-campo__input.v-input--is-disabled >>> input{
    color: rgba(0, 0, 0, 0.54) !important;
}

.c-campo__input.v-input--is-disabled >>> label{
    color: rgba(0, 0, 0, 0.54) !important;
}

.c-campo__input >>> .v-icon{
    color: rgba(0, 0, 0, 0.54) !important;
}

.c-campo__input:not(.v-input--is-disabled) >>> .v-input__slot{
    background-color: white;
}

.c-campo__input:not(.v-input--is-disabled) >>> .v-input__slot{
    background-color: white;
}

.c-campo__botao{
    margin: 4px 5px;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-campo__clona-valor{
    background: #1976d2 !important;
    border-color: #1976d2 !important;
}

</style>